import type { OrderListFilters } from './schema'

export const orderListKeys = {
  all: ['order-list'] as const,
  lists: () => [...orderListKeys.all, 'list'] as const,
  list: (filters: OrderListFilters) => [...orderListKeys.lists(), filters] as const,
  infinite: (filters: Omit<OrderListFilters, 'page'>) =>
    [...orderListKeys.lists(), 'infinite', filters] as const,
}
